// @flow
import * as React from 'react';
import { connect } from 'react-redux';

//import datas from "./data";
import PersonDetails from './personDetails';
import CalCalDataApi from '../../api/CalCalDataApi';

import { Item, Input, Icon, Toast, Form, Text } from 'native-base';
import Alert from '../../components/alert';
import * as _ from 'lodash';

import GLOBALS from '../../components/globals';
//does fetching customer or supplier details; loads main views

class PersonDetailsContainer extends React.Component {
	constructor(props) {
		super(props);
		this.initialState = {};
		this.state = this.initialState;
	}
	componentWillMount() {
		//console.log('Here is a personDetails', this);
		//update cached details of this dude
		//const {state} = this.props.navigation;
		//this.props.dispatch({type: 'REFETCH_PERSON', params.person}); //this will update the daddy store globalReducer
	}

	componentWillUpdate(nextProps) {
		//console.log('will update', nextProps);
	}

	deletePerson(id) {
		const { params } = this.props.route;
		const { personType } = params;
		CalCalDataApi.dataDelete(personType + 's/' + id, this.props.jwt, res => {
			//dispatch({type: 'CUSTOMERS_IS_LOADING', isLoading: false});
			if (res.status == 200 && res.success) {
				this.props.dispatch({
					type: 'DELETE/' + personType,
					id
				});
				this.props.navigation.goBack();
			} else {
				Alert.alert(res.title, 'Cannot delete customer. \n' + res.error);
				if (res.error == 'Expired token')
					dispatch({
						type: 'SET_JWT',
						token: null,
						info: null
					});
			}
		});
	}

	render() {
		//return <Text>Hello 2</Text>;
		//is it a customer or supplier?
		//FAB, details,
		const { params } = this.props.route;
		const personType = params.personType;
		const personId = params.personId;
		const headers = {
			token: this.props.user?.access_token,
			client_id: GLOBALS.client_id,
			client_secret: GLOBALS.client_secret
		};
		//console.log(params, this.props);
		//is it an array?
		var details = [];
		if (personType == 'customer') details = _.find(this.props.customers, { id: personId });
		if (personType == 'supplier') details = _.find(this.props.suppliers, { id: personId });
		//console.log(details);
		//return <Text>Hello 3</Text>;
		return <PersonDetails details={details} headers={headers} jwt={this.props.jwt} personType={personType} navigation={this.props.navigation} deletePerson={id => this.deletePerson(id)} />;
	}
}

function bindAction(dispatch) {
	return {
		dispatch
	};
}
const mapStateToProps = state => ({
	customers: state.globalReducer.customers,
	suppliers: state.globalReducer.suppliers,
	user: state.loginReducer.user,
	busDetails: state.globalReducer.busDetails,
	jwt: state.loginReducer.jwt && state.loginReducer.jwt.token
});
export default connect(mapStateToProps, bindAction)(PersonDetailsContainer);
